import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import chroma from 'chroma-js';

@Component({
  selector: 'bepatient-measure-tile',
  templateUrl: './measure-tile.component.html',
  styleUrls: ['./measure-tile.component.scss'],
  standalone: false
})
export class MeasureTileComponent implements AfterViewInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() icon: string;
  @Input() color: string;
  @Input() content: string;

  contrast: string;
  @ViewChild('tileElement', { read: ElementRef, static: true })
  tileElement: ElementRef;

  ngAfterViewInit(): void {
    // Creating contrast color from color
    if (this.color) {
      this.contrast = chroma(this.color).darken(0.4).hex();
    }
    // on hover: applying contrast color
    this.tileElement.nativeElement.addEventListener('mouseover', () => {
      this.tileElement.nativeElement.style.setProperty(
        'background',
        this.contrast
      );
    });
    // on hover out: removing contrast and applying normal color
    this.tileElement.nativeElement.addEventListener('mouseout', () => {
      this.tileElement.nativeElement.style.setProperty(
        'background',
        this.color
      );
    });
  }
}
